<template>
  <section class="newsletter reveal-section" ref="sectionRef">
    <h2>Recibe Nuestras Historias</h2>
    <p>Suscríbete a nuestro boletín mensual y sé testigo de cómo Dios transforma vidas a través de Vision House.</p>
    <form class="newsletter-form" @submit.prevent="handleSubmit">
      <input type="email" v-model="email" placeholder="tu@email.com" required>
      <ion-button type="submit">Suscribirme</ion-button>
    </form>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonButton } from '@ionic/vue'
import { useScrollReveal, useToast } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
const { showToast } = useToast()
onMounted(() => registerReveal(sectionRef.value))

const email = ref('')
const handleSubmit = () => {
  showToast('¡Bienvenido a nuestra comunidad!', 'success')
  email.value = ''
}
</script>

<style scoped>
.newsletter {
  background: linear-gradient(135deg, var(--vh-azul-profundo), var(--vh-azul-oscuro));
  padding: 5rem 5%; text-align: center; color: white;
  position: relative; overflow: hidden;
}
.newsletter::before {
  content: ''; position: absolute; top: -100px; right: -100px;
  width: 300px; height: 300px; background: var(--vh-dorado);
  border-radius: 50%; opacity: 0.1; filter: blur(60px);
}
.newsletter h2 { font-size: 2.5rem; margin-bottom: 1rem; position: relative; z-index: 1; }
.newsletter p { opacity: 0.9; margin-bottom: 2rem; max-width: 500px; margin-left: auto; margin-right: auto; position: relative; z-index: 1; }
.newsletter-form { display: flex; gap: 1rem; max-width: 500px; margin: 0 auto; position: relative; z-index: 1; }
.newsletter-form input {
  flex: 1; padding: 1.1rem 1.5rem; border: none; border-radius: 50px;
  font-family: 'Open Sans', sans-serif; font-size: 1rem;
  background: rgba(255,255,255,0.15); color: white; backdrop-filter: blur(10px);
}
.newsletter-form input::placeholder { color: rgba(255,255,255,0.7); }
.newsletter-form input:focus { outline: none; background: rgba(255,255,255,0.25); box-shadow: 0 0 0 3px rgba(251, 166, 54, 0.3); }
ion-button {
  --background: var(--vh-dorado); --color: white;
  --border-radius: 50px;
  font-family: 'League Spartan', sans-serif; font-weight: 700;
}
ion-button:hover { --background: var(--vh-dorado-hover); }

@media (max-width: 768px) {
  .newsletter-form { flex-direction: column; }
  ion-button { width: 100%; }
}
</style>
